import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DateTimeFilterService {
  private quickDatePicker = new Subject();
  private datePicker = new Subject();
  constructor() { }


  setQuikcDate(date: Object) {
    this.quickDatePicker.next(date);
  }

  getQuickDate(): Observable<Object> {
    return this.quickDatePicker.asObservable();
  }

  setActiveDateFromPicker(date: Object) {
    this.datePicker.next(date);
  }
  
  getActiveDateFromPicker(): Observable<Object> {
    return this.datePicker.asObservable();
  }
}
